import script from "./Detail.vue?vue&type=script&setup=true&lang=js"
export * from "./Detail.vue?vue&type=script&setup=true&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=6b7f5f18&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7f5f18"]])

export default __exports__